//@ts-check
import React from 'react';
import MultiSelectFormInput from '../MultiSelect';
import TextFormInput from '../Text';
import NumericTextField from '../Numeric/TextField';
import { useFilterContext, getFieldSchema } from './FilterContext';
import FilterExpressionValueEventFormInput from './FilterExpressionValueEvent';
import DateTime from '../DateTime';
/**
 * @param {import('./types').FormInputFilterExpressionValueProps } props
 */

var FilterExpressionValueFormInput = React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      field = _ref.field;

  var _useFilterContext = useFilterContext(),
      schema = _useFilterContext.schema,
      disabled = _useFilterContext.disabled,
      variant = _useFilterContext.variant,
      color = _useFilterContext.color;

  var fieldSchema = getFieldSchema(schema, field);

  if (!fieldSchema || fieldSchema.Type === 'text') {
    if (fieldSchema && fieldSchema.ValidationType === 'numeric') {
      return React.createElement(NumericTextField, {
        value: parseInt(value),
        onChange: _onChange,
        disabled: disabled,
        variant: variant,
        color: color
      });
    } else {
      return (// @ts-ignore
        React.createElement(TextFormInput, {
          inputRef: ref,
          value: value || '',
          onChange: function onChange(e) {
            return _onChange(e.target.value);
          },
          disabled: disabled,
          variant: variant,
          color: color,
          placeholder: "Empty value"
        })
      );
    }
  }

  if (fieldSchema.Type === 'selection') {
    /**@type {import('../MultiSelect/types').MultiSelectOptions} */
    var options = fieldSchema.Selection.map(function (option) {
      return {
        label: option.Caption,
        value: option.Value
      };
    });
    return React.createElement(MultiSelectFormInput, {
      ref: ref,
      key: field,
      value: value || '',
      onChange: _onChange,
      options: options,
      disabled: disabled,
      variant: variant,
      color: color
    });
  }

  if (fieldSchema.Type === 'dialog') {
    if (fieldSchema.Name === 'Event') {
      return React.createElement(FilterExpressionValueEventFormInput, {
        ref: ref,
        value: value,
        onChange: _onChange,
        variant: variant,
        disabled: disabled,
        color: color
      });
    }
  }

  if (fieldSchema.Type === 'time' || fieldSchema.Type === 'date' || fieldSchema.Type === 'datetime') {
    return React.createElement(DateTime, {
      value: value,
      onChange: _onChange,
      variant: variant,
      disabled: disabled,
      color: color,
      type: fieldSchema.Type
    });
  }

  return null;
});
FilterExpressionValueFormInput.defaultProps = {};
export default React.memo(FilterExpressionValueFormInput);